exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".estimate-create-page .estimate-foot .estimate-total {\n  min-width: 390px;\n}\n@media (max-width: 480px) {\n.estimate-create-page .estimate-foot .estimate-total {\n    min-width: 384px !important;\n}\n}", ""]);

// exports
